import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const CoverPageStyles = styled.div`
  .inner-container {
    .voluntary-wrapper {
      gap: normal;
      @media (min-width: ${theme.grid.resolution.tablet.width}px) {
        width: 50%;
      }
    }
    .compulsory-wrapper {
      @media (min-width: ${theme.grid.resolution.tablet.width}px) {
        width: 44%;
      }
    }
  }
  .cover-benefits {
    overflow: visible;
    .divider-wrapper {
      display: none;
      @media (min-width: ${theme.grid.resolution.tablet.width}px) {
        display: block !important;
      }
    }
    &.open {
      .divider-wrapper {
        display: block !important;
      }
    }
  }
  .overlay-wrapper {
    .dismiss-wrapper {
      top: 22px !important;
      right: 26px !important;
      svg {
        width: 23px !important;
        height: 23px !important;
      }
    }
  }
  .popup-title {
    margin-bottom: ${theme.grid.spacing.base}px;
    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      margin-bottom: ${theme.grid.spacing.md}px;
    }
    @media (min-width: ${theme.grid.resolution.desktop.width}px) {
      margin-bottom: ${theme.grid.spacing.s}px;
    }
  }
  .popup-description {
    margin-bottom: ${theme.grid.spacing.base}px;
    @media (min-width: ${theme.grid.resolution.desktop.width}px) {
      margin-bottom: ${theme.grid.spacing.l}px;
    }
  }
  .popup-button-wrapper {
    width: 100%;
    text-align: center;
    .popup-button {
      margin: auto;
      width: 159px;
      height: 64px;
    }
  }

  .popup-overlay {
    .overlay-wrapper {
      @media (min-width: ${theme.grid.resolution.tablet.width}px) {
        width: 696px;
        max-width: unset;
      }
      @media (min-width: ${theme.grid.resolution.desktop.width}px) {
        width: 912px;
        max-width: unset;
      }
    }
  }
`
